import { fakePromiseDelay, useAppTranslation } from "@/utils";
import { bnplConsumerApis } from "@payping/api";
import type { SDKRequestInit } from "@payping/api";
import { Button, Flex, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { FC } from "react";
import PayGetOrderLayout from "../Layout";

interface StartProps {
  onFinish: () => void;
  trackingCode: string;
  unknownFinish: () => void;
}
const PayGetOrderCreditScoreStart: FC<StartProps> = ({ onFinish, trackingCode, unknownFinish }) => {
  const { t } = useAppTranslation();

  const [{ loading }, start] = useMessagedAsyncFn(async () => {
    try {
      const res = await bnplConsumerApis.creditScoreValidationOTP({ trackingCode }, {
        isRaw: true,
      } as SDKRequestInit);
      onFinish();
      return res;
    } catch (e: any) {
      // Check if e is an instance of Response and if the status is 400
      if (e.status === 400) {
        try {
          const parsedError = await e.json();
          // report did not success
          if ((parsedError as any)?.key === 112) {
            // 10 seconds fake delay
            await fakePromiseDelay(10000);
            unknownFinish();
            return undefined;
          }
          throw parsedError;
        } catch (jsonError: any) {
          if (jsonError.status === 400) {
            throw jsonError;
          }
          throw e; // Fallback if parsing JSON fails
        }
      }
      throw e;
    }
  }, [onFinish, trackingCode, unknownFinish]);

  const handleClickStart = () => {
    start();
  };

  return (
    <PayGetOrderLayout showHeaders>
      <Flex vertical className="tw:h-full tw:w-full tw:px-4! tw:pb-4! tw:pt-6!" gap={"middle"}>
        <Flex gap={"small"} vertical>
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold">
            {t("pay.getOrder.steps.creditScore.title")}
          </Typography.Title>
          <Typography.Paragraph>{t("pay.getOrder.steps.creditScore.description")}</Typography.Paragraph>
        </Flex>
        <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"} vertical>
          <Flex gap={"middle"} className="tw:w-full">
            <Button
              loading={loading}
              block
              type="primary"
              onClick={() => {
                handleClickStart();
              }}
            >
              {t("pay.getOrder.steps.creditScore.start")}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </PayGetOrderLayout>
  );
};

export default PayGetOrderCreditScoreStart;
